<script setup lang="ts">
import { routeInstanceKey } from "@/router/routeIdentity";
import { formatYear } from "@/utils/dateHelpers";
</script>

<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <router-view v-slot="{ Component, route }">
          <component :is="Component" :key="routeInstanceKey(route)" />
        </router-view>
      </v-container>
    </v-main>

    <v-footer app class="d-flex flex-column">
      <div class="text-center">
        <span
          >Powered by <a href="https://toasthost.co.uk" target="_blank">ToastHost</a> &copy;
          {{ formatYear(new Date()) }}</span
        >
      </div>
    </v-footer>
  </v-app>
</template>
